// store/modules/disposals/actions.js
import DisposalApi from "../../../api/modules/DisposalApi";

const searchDisposals = (_, payload) => {
  return DisposalApi.searchDisposals(payload.context, payload.idClient, payload);
};

const saveDisposal = (_, payload) => {
  return DisposalApi.saveDisposal(payload.context, payload.payload);
};

const getDisposalById = (_, payload) => {
  return DisposalApi.getDisposalById(payload.context, payload.idClient, payload.id);
};

const cancelDisposal = (_, payload) => {
  return DisposalApi.cancelDisposal(payload.context, payload.idClient, payload.idDisposal);
};

export default {
  searchDisposals,
  saveDisposal,
  getDisposalById,
  cancelDisposal
};



// WEBPACK FOOTER //
// ./src/store/modules/disposals/actions.js